import _ from 'underscore';
import moment from 'moment';
import Papa from 'papaparse';

angular.module('am4')
.controller('dashboardCtrl', function(
    $scope,
    $rootScope,
    $q,
    $state,
    $timeout,
    $translate,
    $filter,
    $element,
    $window,
    machineService,
    orgFacService,
    filterService,
    errorService,
    elasticList,
    ngDialog,
    workoutDataService,
    appCacheService,
    filter,
    downloadService,
    viewableMachines,
    errorCodeService,
    REGEX) {

    var that = this,
        allMachineData,
        viewableMachinesSearchClone,
        allOptions,

         // pop open modal to save a filter
        closeModal;

    that.infiniteScrollFooter = require('../views/dashboard/dashboardFooter.html');

    that.state = appCacheService.getAppCache('appState');

    that.options = filter ? filter.options : that.state.dashboardOptions;

    that.viewableMachines = [];
    that.pageLength = 50;
    that.infiniteScrollDistance = 1;

    that.getFilterPredicate = function() {
        if (that.state.activeMachinesOnly && that.state.deleted) {
            return m => m.is_active;
        }
        if (that.state.activeMachinesOnly && !that.state.deleted) {
            return m => m.is_active && !m.is_removed;
        }
        if (!that.state.activeMachinesOnly && !that.state.deleted) {
            return m => !m.is_removed;
        }
        return () => true;
    };

    that.showMoreMachines = function() {
        if (that.limitMachinesDisplayed < that.viewableMachines.length) {
            that.limitMachinesDisplayed += that.pageLength;
        }
    };

    function updateViewableMachines() {
        resetViewableMachinesLimit();
        that.viewableMachines = _.filter(viewableMachines(), that.getFilterPredicate());
    }

    function resetViewableMachinesLimit() {
        that.limitMachinesDisplayed = that.pageLength;
    }

    that.searchTerm = {
        text: ''
    };

    that.checked = {};

    // function to filter machines upon input of a search term
    that.filterMachines = _.debounce(filterMachines, 250);

    function filterMachines() {
        that.searchTerm.searchRegex = new RegExp(that.searchTerm.text
            .replace(REGEX.REGEX_CHARACTERS, '\\$&')
            .split(REGEX.SPACES)
            .join('.*'), 'i');

        viewableMachines(_.filter(viewableMachinesSearchClone, function(mach) {
            return that.searchTerm.searchRegex.test(mach.search);
        }));

        $timeout(function() {
            handleDataChange('search');
        });
    }

    // variable to store lookup tables for org_id and org_name and same for facility
    that.orgLookup = {};
    that.facLookup = {};

    that.getMachineData = function(firstTime) {

        that.loading = true;

        // get data from machine service
        return $q.all([
            machineService.getMachineData(),
            orgFacService.getOrganizationsDictionary(),
            orgFacService.getFacilitiesDictionary()
        ])
        .then(function(responses) {
            that.orgLookup = responses[1];
            that.facLookup = responses[2];

            // Determine if any elastic columns need to be hidden
            that.hasMultipleOrgs = Object.keys(that.orgLookup).length > 1;
            that.hasMultipleFacs = Object.keys(that.facLookup).length > 1;

            allMachineData = responses[0].machines;
            viewableMachines(responses[0].machines);
            viewableMachinesSearchClone = viewableMachines();
            that.elasticListTree = elasticList(allMachineData, !that.state.activeMachinesOnly);
            that.availableOptions = sortAvailableOptions(that.elasticListTree.availableOptions);
            allOptions = _.clone(that.availableOptions);
            handleDataChange('getMachineData');
            // if firstload, create static variables
            if (firstTime) {
                that.state.firstLoad = false;
            }
        })
        .then(function() {
            // a preset has been given, load it
            if (filter) {
                that.loadPresetOptions(filter.options);
            } else {
                that.loadPresetOptions(that.state.dashboardOptions);
            }

            // Run initial time just in case machines being filtered changed while
            // off the dashboard on another page
            filterMachines();
        })
        .catch(function() {
            $state.go('app.500', {
                location: false
            });
        })
        .finally(function() {
            that.loading = false;
        });
    };

    that.changeSorting = function(facet, descending, updateViewable) {
        that.state.sort.facet = facet;
        that.state.sort.descending = descending;

        viewableMachines(_.sortBy(viewableMachines(), that.state.sort.facet));
        if (that.state.sort.descending) {
            viewableMachines(viewableMachines().reverse());
        }

        if (updateViewable) {
            updateViewableMachines();
        }
    };

    // NOTE: This function is not called when the user goes back to the dashboard from another screen.
    function getFilteredData() {

        if (isEmptyFilter(that.options)) {
            viewableMachines(allMachineData);
            viewableMachinesSearchClone = viewableMachines();
            handleDataChange('toggleOptionsWithoutFilter');
        } else {
            filterCleanup(that.options);
            viewableMachinesSearchClone = viewableMachines();
            handleDataChange('toggleOptionsWithFilter');
        }
    }

    that.toggleOptions = function(option, facet) {
        // if toggling off, splice element out of options array
        if (that.options[facet].indexOf(option) > -1) {
            that.options[facet].splice(that.options[facet].indexOf(option), 1);
        } else {
            // otherwise push it
            that.options[facet].push(option);
        }

        that.state.currentElasticOptions = that.options;
        if (!filter) {
            that.state.dashboardOptions = that.options;
        }

        getFilteredData();
    };

    that.removeStatusOptions = function() {
        that.options.status = [];
        getFilteredData();
    };

    that.loadPresetOptions = function(paramOptionObj) {
        var optionObj = _.defaults(paramOptionObj, that.elasticListTree.defaultOptions);
        filterCleanup(optionObj);
        viewableMachinesSearchClone = viewableMachines();
        handleDataChange('loadPresetOptions');
    };

    that.openModal = function() {
        // initalize value to show up in the filter name text box
        that.filterName = {
            value: filter && filter.name ? filter.name : ''
        };

        var filterModalScope = $scope.$new();
        filterModalScope.createFilter = that.createFilter;
        filterModalScope.filterName = that.filterName;

        closeModal = ngDialog.open({
            template: require('../views/modal/filter.html'),
            plain: true,
            scope: filterModalScope
        }).close;
    };

    // function to create filter
    that.createFilter = function() {
        that.filterName.isSaving = true;

        // grab uuid and owner
        var uuid = filter && filter.filter_uuid ? filter.filter_uuid : null,
            owner = filter && filter.owner_id ? filter.owner_id : null;

        // if new name is provided, create filter through service
        return filterService.createFilter(
            uuid,
            that.filterName.value,
            that.options,
            owner
        )
        .then(function(res) {
            // emit a signal to update the tabbar tabs and close popup
            $scope.$emit('updateTabs');

            return $state.go('app.am4.dashboard.results', {
                filterId: res.filter_uuid,
                filter: res
            });
        })
        .catch(function(e) {
            errorService.addError('CREATE_FILTER_ERROR', e);
        })
        .finally(function() {
            closeModal();
        });
    };

    that.exportMachines = function() {
        // Remove $$hashKey from the objects
        var machines = angular.copy(viewableMachines());

        // Remove the search key from the objects
        for (let i = 0; i < machines.length; i++) {
            delete machines[i].search;
        }

        for (let prop in machines[0]) {
            if (machines[0].hasOwnProperty(prop)) {
                // Only do this once since it's cpu-intensive
                let t = $translate.instant(prop.toUpperCase());

                for (let j = 0; j < machines.length; j++) {
                    machines[j][t] = machines[j][prop];
                    delete machines[j][prop];
                }
            }
        }

        downloadService('am4-dashboard-results-' + moment().format() + '.csv', Papa.unparse(machines));
    };

    that.toggleActiveOnly = function() {
        that.state.activeMachinesOnly = !that.state.activeMachinesOnly;
        filterMachines();
    };

    that.toggleDeleted = function() {
        that.state.deleted = !that.state.deleted;
        filterMachines();
    };

    function handleDataChange(origin) {

        if (_.indexOf(['toggleOptionsWithFilter', 'toggleOptionsWithoutFilter'], origin) > -1 && that.searchTerm.text !== '') {
            viewableMachines(_.filter(viewableMachinesSearchClone, function(mach) {
                return that.searchTerm.searchRegex.test(mach.search);
            }));
        }

        that.changeSorting(that.state.sort.facet, that.state.sort.descending, true);

        if (origin === 'toggleOptionsWithFilter' || origin === 'loadPresetOptions') {
            that.availableOptions = sortAvailableOptions(that.elasticListTree.availableOptions);
            that.options = that.elasticListTree.treeOptions;

            that.state.currentElasticOptions = that.options;
            if (!filter) {
                that.state.dashboardOptions = that.options;
            }
            makeChecked(that.options);
            updateBreadcrumbs();
        } else if (origin === 'toggleOptionsWithoutFilter') {
            that.availableOptions = allOptions;
            makeChecked(that.options);
            updateBreadcrumbs();
        }
    }

    function makeChecked(options) {
        _.each(options, function(facet, index) {
            that.checked[index] = {};
            _.each(facet, function(selection) {
                that.checked[index][selection] = true;
            });
        });
    }


    // function to update the filter breadcrumbs
    function updateBreadcrumbs() {
        var keys = _.keys(that.elasticListTree.defaultOptions);
        that.filteringOnAry = _.reduce(keys, function(memo, facet) {
            // get array of each facet's selected options
            var facetResults = _.filter(_.keys(that.checked[facet]), function(key) {
                    return that.checked[facet][key] === true;
                }),
                andTranslation = ' ' + $translate.instant('AND').toUpperCase() + ' ';


            switch (facet) {
            case 'organization_id':
                facetResults = _.map(facetResults, function(res) {
                    return {
                        display: that.orgLookup[res],
                        value: +res,
                        facet: 'organization_id'
                    };
                });
                break;

            case 'facility_id':
                facetResults = _.map(facetResults, function(res) {
                    return {
                        display: that.facLookup[res],
                        value: +res,
                        facet: 'facility_id'
                    };
                });
                break;

            case 'status':
                facetResults = facetResults.length > 0 ? [{
                    display: $translate.instant('STATUS') + ': ' + _.map(facetResults, function(res) {
                        return $translate.instant(res);
                    }).join(andTranslation),
                    facet: 'status'
                }] : [];
                break;

            case 'machine_type_code':
                // Deduplicate by CMS key so case variants (e.g. "Massage Chair" / "massage chair") show one breadcrumb
                var seenCmsKeys = {};
                facetResults = _.reduce(facetResults, function(memo, res) {
                    var cmsKey = res ? res.toUpperCase().replaceAll(' ', '_') : '';
                    if (seenCmsKeys[cmsKey]) return memo;
                    seenCmsKeys[cmsKey] = true;

                    var facetDisplay = res;
                    if (facetDisplay === '') {
                        facetDisplay = $translate.instant('EQUIPMENT_TYPE') + ': ' + $translate.instant('UNKNOWN');
                    } else {
                        facetDisplay = $translate.instant(cmsKey);
                    }
                    memo.push({
                        display: facetDisplay,
                        value: res,
                        facet: 'machine_type_code'
                    });
                    return memo;
                }, []);
                break;

            case 'series':
                facetResults = _.map(facetResults, function(res) {
                    var facetDisplay = res;
                    if (facetDisplay === '') {
                        facetDisplay = $translate.instant('MODEL_CODE') + ': ' + $translate.instant('UNKNOWN');
                    }
                    return {
                        display: $filter('seriesName')(facetDisplay),
                        value: res,
                        facet: 'series'
                    };
                });
                break;

            default:
                break;
            }

            return memo.concat(facetResults);
        }, []);
        // concat the filteringOn array together
    }

    // function to find if a filter is empty
    function isEmptyFilter(filter) {
        return _.every(_.map(filter, _.isEmpty));
    }

    function sortWithLookup(choices, lookup) {
        return choices.sort(function(a, b) {
            if (_.isNull(a)) {
                return 1;
            }
            if (_.isNull(b)) {
                return -1;
            }

            if (_.isUndefined(lookup[a])) {
                return -1;
            }
            if (_.isUndefined(lookup[b])) {
                return 1;
            }

            return lookup[a].localeCompare(lookup[b]);
        });
    }

    function sortAvailableOptions(options) {

        /* eslint-disable no-param-reassign */
        _.each(options, function(choices, index) {
            if (index === 'organization_id') {
                // compare lookup strings for display purposes
                choices = sortWithLookup(choices, that.orgLookup);
            } else if (index === 'facility_id') {
                choices = sortWithLookup(choices, that.facLookup);
            } else if (index === 'machine_type_code') {
                choices = sortWithLookup(choices, choices.reduce(function(memo, current) {
                    memo[current] = typeof current === 'string' ? $translate.instant(current.toUpperCase().replaceAll(' ', '_')) : $translate.instant('NA');
                    return memo;
                }, {}));
            } else if (_.find(choices, isNaN)) {
                choices = choices.sort((a, b) => {
                    if (_.isNull(a)) {
                        return 1;
                    }
                    if (_.isNull(b)) {
                        return -1;
                    }
                    return a.localeCompare(b);
                });
            } else {
                // otherwise sort numerically
                choices = choices.sort(function(a, b) {
                    return (+a) - (+b);
                });
            }
        });

        /* eslint-enable */
        return options;
    }

    // TAG FOR REFACTOR.
    // This concept should be used alongside a rules-engine implementation in future versions of the system.
    function filterCleanup(options) {
        // For now, this applies only to the "HAS_ERROR_CODE" filter option. Can be extended to include other filter options as well.
        if ( options.status.includes('HAS_ERROR_CODE') ) {
            // If the user is executing a filter for machines that contain errors, make sure that any unapproved
            // errors (i.e., errors with no descriptions in our system) are not displayed.
            var cleanErrors = errorCodeService.haveDescriptionsOnly(that.elasticListTree.treeSearch(that.options));
            cleanErrors = errorCodeService.previousDayOnly(cleanErrors);

            // If this is a customer, remove all "alerts" ("B" or "C" severity) from the results.
            if ($rootScope.logged_in_user.user_metadata.am_roles.includes('CUSTOMER_ADVANCED') ||
            $rootScope.logged_in_user.user_metadata.am_roles.includes('CUSTOMER_BASIC')) {
                // eslint-disable-next-line one-var
                var errorSearchResults = errorCodeService.highSeverityOnly(cleanErrors);
                viewableMachines(errorSearchResults);
            } else {
                // Internal user; show all records (except records with no error descriptions).
                viewableMachines(cleanErrors);
            }
        } else {
            // This was not an error search; allow the filtering to continue as normal.
            viewableMachines(that.elasticListTree.treeSearch(that.options));
        }
    }

    $scope.$watch(function() {return that.state;}, function(newVal) {
        appCacheService.setAppCache('appState', newVal);
    }, true);

    that.getMachineData(that.state.firstLoad);
});



// WEBPACK FOOTER //
// ./src/app/controllers/dashboardCtrl.js